import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { ProStudioEvents, ProStudioContext } from '../prostudio.xstate.types';
import { loadBotPypes } from './load-bot-pypes';
import { Pype } from '../prostudio.api-service.types';

export const deleteChannel = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{ botPypes: Pype[] } | void> => {
  if (event.type !== 'deleteChannel') {
    return;
  }

  const projectId = ctx.project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  const uniqueCustomerId = ctx.project?.projectProStudioSetting?.customerId;

  if (!uniqueCustomerId) {
    throwErrorWithId('Customer ID is required');
    return;
  }

  const { cb, pypeId, env } = event.payload;

  const mutation = {
    live: urqlGql.deletePypeLive,
    sandbox: urqlGql.deletePypeSandbox,
  };

  const deletePype = mutation[env];

  await deletePype({
    projectId,
    customerId: uniqueCustomerId,
    id: pypeId,
  });

  cb?.();

  const { botPypes } = await loadBotPypes(ctx, event);

  return { botPypes };
};
